import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, Grid, Stack, Typography } from '@mui/material'
import { CardTitle } from 'common/components/card/Card'
import { darkBlue } from 'app/theme'

const fmt = (v) => (Number.isFinite(v) ? `${v}` : '—')

const StatColumn = ({ label, value }) => (
    <Grid size={4}>
        <Stack alignItems='center' spacing={0.25}>
            <Typography variant='h4'>{value}</Typography>
            <Typography variant='body2' color='textSecondary' align='center'>{label}</Typography>
        </Stack>
    </Grid>
)

StatColumn.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

const VersionsStatsCards = ({ averages = {} }) => {
    const { moyenneComplete, moyenne5, moyenneAnnee, nbVersions } = averages
    return (
        <Card sx={{ height: '100%' }}>
            <CardTitle
                title='Bugs critiques post-release'
                actions={[{
                    icon: 'info_outlined',
                    tooltip: 'Tickets catégorie Anomalie, priorité Urgente ou Immédiate, créés dans les 15 jours suivant la mise en production d\'une version (fenêtre plafonnée à la version suivante).',
                }]}
                color={darkBlue}
            />
            <CardContent sx={{ '&:last-child': { paddingBottom: 2 } }}>
                <Grid container alignItems='flex-start'>
                    <StatColumn label='Toutes versions' value={fmt(moyenneComplete)} />
                    <StatColumn label='5 dernières' value={fmt(moyenne5)} />
                    <StatColumn label='Sur l’année' value={fmt(moyenneAnnee)} />
                </Grid>
                <Typography variant='caption' color='textSecondary' align='center' component='div' sx={{ marginTop: 1 }}>
                    {`Moyenne de bugs par version — sur ${nbVersions ?? 0} versions`}
                </Typography>
            </CardContent>
        </Card>
    )
}

VersionsStatsCards.propTypes = {
    averages: PropTypes.shape({
        moyenneComplete: PropTypes.number,
        moyenne5: PropTypes.number,
        moyenneAnnee: PropTypes.number,
        nbVersions: PropTypes.number,
    }),
}

export default VersionsStatsCards
